var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgToggleLogoMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 16
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M7.854 2.426c2.806 0 5.101 2.304 5.101 5.12 0 2.816-2.295 5.12-5.101 5.12s-5.102-2.304-5.102-5.12c0-2.816 2.296-5.12 5.102-5.12zm0-2.41C3.728.017.352 3.407.352 7.547c0 4.142 3.376 7.53 7.502 7.53 4.126 0 7.502-3.388 7.502-7.53 0-4.14-3.376-7.53-7.502-7.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "toggle-logo-mobile_svg__logoColor",
    fill: "#FFA852",
    d: "M20.797 0H15.01a10.474 10.474 0 013.18 7.53c0 2.954-1.223 5.629-3.18 7.529h5.788c4.079 0 7.415-3.388 7.415-7.53C28.212 3.39 24.876 0 20.797 0"
  }))));
}

export default SvgToggleLogoMobile;